import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ForgotPasswordService } from 'src/app/services/forgot-password.service';


@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  isSubmitting = false;
  successMessage: string = '';
  isError: boolean = false;
  errorMessage: string = '';

  constructor(private fb: FormBuilder, private forgotPasswordService: ForgotPasswordService) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get f() {
    return this.forgotPasswordForm.controls;
  }

  onSubmit() {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.isSubmitting = true;
    this.successMessage = '';
    this.isError = false;
    this.errorMessage = '';

    // Call the service to send reset link
    this.forgotPasswordService.sendResetLink(this.forgotPasswordForm.value.email)
      .subscribe({
        next: (response) => {
          this.isSubmitting = false;

          // Check the status in the response
          if (response.status === true) {
            this.successMessage = 'Password reset link has been sent to your email.';
          } else {
            this.isError = true;
            this.errorMessage = response.message;
          }
        },
        error: (err) => {
          this.isSubmitting = false;
          this.isError = true;
          this.errorMessage = 'An error occurred. Please try again later.';
        }
      });
  }
}
